import { FOUNDER_URL, TILE_META_EXTRAS } from "../constants/data";
import useCategoryImages from "../hooks/useCategoryImages";
import TileImage from "../components/shared/TileImage";

export default function About() {
  const overrides = useCategoryImages();
  return (
    <div className="pt-32 pb-20" data-testid="about-page">
      <section className="container-x">
        <p className="label-small">Our Story</p>
        <h1 className="font-serif text-5xl sm:text-6xl text-[#2D2424] mt-3">About Naathi Charami</h1>

        <div className="mt-12 grid lg:grid-cols-2 gap-12 items-center">
          <div className="aspect-[4/5] overflow-hidden bg-[#F2E8E4]">
            <TileImage
              src={overrides.founder}
              loaded={overrides.loaded}
              fallback={FOUNDER_URL}
              alt="Monalika Reddy — Founder"
              className="w-full h-full object-cover"
              icon="heart"
            />
          </div>

          <div>
            <p className="font-serif italic text-2xl text-[#7A1F2B]">"Naathi Charami means — I shall never leave your side."</p>
            <p className="mt-6 text-[#5C5555] leading-relaxed">
              Founded by <span className="font-medium text-[#2D2424]">Monalika Reddy</span>, Naathi Charami Gifts &amp; Hampers offers A–Z gifting solutions for every occasion — creating meaningful gifting experiences with creativity and care.
            </p>
            <p className="mt-4 text-[#5C5555] leading-relaxed">
              Born from the belief that every gift carries a promise, we curate hampers that say what words sometimes cannot. From intimate baby showers and elegant weddings to thoughtful corporate gestures — every box is wrapped with intention, every detail considered.
            </p>
            <p className="mt-4 text-[#5C5555] leading-relaxed">
              Based in Hyderabad, our team works with artisans, premium brands and trusted local suppliers to ensure every hamper reflects the love and togetherness our name promises.
            </p>

            <div className="grid grid-cols-3 gap-6 mt-10 pt-8 border-t border-[#E5DBD8]">
              <div>
                <p className="font-serif text-3xl text-[#7A1F2B]">500+</p>
                <p className="text-xs tracking-wider uppercase text-[#5C5555] mt-1">Gifts Delivered</p>
              </div>
              <div>
                <p className="font-serif text-3xl text-[#7A1F2B]">50+</p>
                <p className="text-xs tracking-wider uppercase text-[#5C5555] mt-1">Curated Hampers</p>
              </div>
              <div>
                <p className="font-serif text-3xl text-[#7A1F2B]">100%</p>
                <p className="text-xs tracking-wider uppercase text-[#5C5555] mt-1">Handcrafted</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Behind the scenes banner */}
      <section className="mt-16 sm:mt-20" data-testid="about-side-banner">
        <div className="container-x">
          <p className="label-small text-center">Behind the Scenes</p>
          <h2 className="font-serif text-3xl sm:text-4xl text-center text-[#2D2424] mt-2">Every hamper, wrapped with love</h2>
        </div>
        <div
          className="mt-8 relative aspect-[16/6] sm:aspect-[16/5] w-full overflow-hidden"
          style={{ boxShadow: "0 8px 24px -12px rgba(45,36,36,0.25)" }}
        >
          <TileImage
            src={overrides["about-side"]}
            loaded={overrides.loaded}
            fallback={TILE_META_EXTRAS["about-side"].image}
            alt="Behind the scenes — Naathi Charami workshop"
            className="w-full h-full object-cover"
          />
          {/* Soft cream vignette on left for readability */}
          <div className="absolute inset-y-0 left-0 w-1/3 bg-gradient-to-r from-[#FFFAF3]/60 to-transparent pointer-events-none hidden sm:block" />
        </div>
      </section>
    </div>
  );
}
